import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ik, ikSet } from '../utils/imagekit.js';

export default function Hero({ banners }) {
  const list = (banners || []).filter((b) => b.title || b.image);
  const [i, setI] = useState(0);

  useEffect(() => {
    if (list.length < 2) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % list.length), 6000);
    return () => clearInterval(t);
  }, [list.length]);

  if (!list.length) return <div className="hero hero--empty" />;

  return (
    <section className="hero" aria-roledescription="carousel">
      {list.map((b, idx) => {
        const external = /^https?:/i.test(b.link || '');
        const Cta = b.cta && b.link ? (external ? 'a' : Link) : null;
        const ctaProps = external ? { href: b.link } : { to: b.link };
        return (
          <div key={b.id || idx} className={`hero__slide hero__slide--${b.theme === 'light' ? 'light' : 'dark'}${idx === i ? ' is-active' : ''}`} aria-hidden={idx !== i}>
            {b.image && <img src={ik(b.image, 1600)} srcSet={ikSet(b.image, [640, 960, 1280, 1600])} sizes="100vw" alt="" className="hero__img" loading={idx === 0 ? 'eager' : 'lazy'} />}
            <div className="hero__copy">
              {b.title && <h2>{b.title}</h2>}
              {b.subtitle && <p>{b.subtitle}</p>}
              {Cta && <Cta {...ctaProps} className="btn btn--light" tabIndex={idx === i ? 0 : -1}>{b.cta}</Cta>}
            </div>
          </div>
        );
      })}
      {list.length > 1 && (
        <div className="hero__dots">
          {list.map((b, idx) => (
            <button key={b.id || idx} type="button" className={idx === i ? 'is-active' : ''} onClick={() => setI(idx)} aria-label={`Show banner ${idx + 1}`} />
          ))}
        </div>
      )}
    </section>
  );
}
